module.exports = __webpack_public_path__ + "static/media/tomato.05bdd494.png";